import * as types from '../mutation-types'
// import * as router from '../../router'
// import router from '../../router/index'
import axios from 'axios'

// state
export const state = {
  betriebe: [],
  suchbegriff: '',
  leistungen: [],
  staedte: [],
  plz: '',
  limit: 16,
  kh: '',
  geoip: [],
  error: '',
  HeimatStadt: '',
  standortwert: [
    {
      name: '',
      lng: '',
      lat: '',
      typ: '',
      accuracy: ''
    }
  ]
}

// const geoURL = 'https://blip.runway7.net/'

// mutations
export const mutations = {
  [types.FETCH_BETRIEBE_SUCCESS] (state, { betriebe }) {
    state.betriebe = betriebe
  },
  [types.DELETE_BETRIEBE] (state) {
    state.betriebe = []
    state.suchbegriff = []
    state.suchbegriffmanuell = ''
  },

  // Standort typen
  // 1 = hardcode aus suche
  // 2 = navigator.geolocation
  // 3 = marker gezogen
  [types.FETCH_BETRIEBE_SUCCESS_STANDORT] (state, { standort }) {
    var lat
    var lng
    // var accuracy
    // var typ

    state.stadt = standort.name

    if (state.standortwert[0].typ < 2) {
      lat = standort.geo_lat
      lng = standort.geo_lng

      state.standortwert[0].lat = lat
      state.standortwert[0].lng = lng
      state.standortwert[0].name = standort.name
      state.standortwert[0].typ = 1
      console.log('vuex typ 1')
    }
    state.standortwert[0].name = standort
  },
  [types.NEUER_MARKER_SUCCESS] (state, { standort }) {
  //  console.log(standort)
    state.standortwert[0].lat = standort.lat
    state.standortwert[0].lng = standort.lng

    state.standortwert[0].typ = 3
    console.log('vuex typ 3')
    // console.log(standort)
    // -
    // state.geoip = geoip;
  },
  [types.NEUER_GEOLOCATE_SUCCESS] (state, { standort }) {
    if (state.standortwert[0].typ < 3) {
      state.standortwert[0].lat = standort.lat
      state.standortwert[0].lng = standort.lng
      state.standortwert[0].accuracy = standort.accuracy
      state.standortwert[0].typ = 2
    }
  },
  [types.GEOLOCATE_RESET] (state) {
    state.standortwert[0].lat = ''
    state.standortwert[0].lng = ''
    state.standortwert[0].accuracy = ''
    state.standortwert[0].typ = ''
  },
  [types.NEUER_GEOLOCATE_DURCH_STADTWAHL_SUCCESS] (state, { standort }) {
   // console.log('vuexfunc:')
   // console.log(standort)

    state.standortwert[0].lat = standort.geo_lat
    state.standortwert[0].lng = standort.geo_lng
    // state.standortwert[0].accuracy = standort.accuracy

    state.standortwert[0].typ = 3
  },
  [types.FETCH_BETRIEBE_SUCCESS_SET_INNUNGEN] (state, { innungen }) {
    if (innungen) {
      state.innungen = innungen
    }
  },
  [types.FETCH_BETRIEBE_SUCCESS_SET_LEISTUNG] (state, { leistung }) {
    if (leistung) {
      state.leistung = leistung
    }
  },

  [types.SET_BETRIEBE_SUCHBEGRIFF] (state, { suchbegriff }) {
    if (suchbegriff) {
      state.suchbegriff = suchbegriff
    }
  },
  [types.SET_BETRIEBE_SUCHBEGRIFFMANUELL] (state, { suchbegriff }) {
    if (suchbegriff) {
      state.suchbegriffmanuell = suchbegriff
    }
  },
  [types.SET_BETRIEBE_PLZ] (state, { plz }) {
    if (plz) {
      state.plz = plz
    }
  },
  [types.SET_BETRIEBE_RADIUS] (state, { radius }) {
    if (radius) {
      state.radius = radius
    }
  },
  [types.SET_BETRIEBE_STANDORT] (state, { standort }) {
    console.log('set standort: ' + standort)
    if (standort) {
    }
  },
  [types.SET_BETRIEBE_KH] (state, { kh }) {
    if (kh) {
      state.kh = kh
    }
  },
  [types.FETCH_BETRIEBE_CLEAR] (state) {
    state.error = ''
    state.suchbegriff = []
    state.suchbegriffmanuell = ''
    state.plz = ''
    state.stadt = ''
    state.radius = ''
    state.limit = 16
    state.kh = ''
  },

  [types.FETCH_BETRIEBE_FAILURE] (state) {
    console.log('Fehler beim Suchen')
    state.error = 'nichts gefunden'
  },

  [types.FETCH_GEOIP_SUCCESS] (state, { geoip }) {
    state.geoip = geoip
  },
  [types.FETCH_GEOIP_FAILURE] (state) {
    console.log('Fehler beim GEOIP')
  },
  [types.SET_HEIMATSTADT_SUCCESS] (state, { standort }) {
    console.log('neue Heimatstadt..' + standort)
    state.HeimatStadt = standort
  },
  [types.SET_LEISTUNGEN] (state, { leistungen }) {
    if (leistungen) {
      state.leistungen = leistungen
    }
  },
  [types.SET_STAEDTE] (state, { staedte }) {
    if (staedte) {
      state.staedte = staedte
    }
  }
}

// actions
export const actions = {

  async fetchBetriebe ({ commit }, payload) {
    let response
    try {
      response = await axios.get('/api/v1/suche/', {
        params: {
          leistung: payload.leistung,
          standort: payload.standort,
          karte: true,
          postleitzahl: payload.postleitzahl,
          erweitert: payload.erweitert,
          kh: payload.kh,
          range: payload.range
        }
      })
    } catch (ex) {
      commit(types.FETCH_BETRIEBE_FAILURE)

      this.dispatch('responseMessage', {
        type: 'warning',
        text: 'Leider keine passenden Betriebe gefunden.'
      })
      return
    }
    const data = response.data
    // console.log(data)
    commit(types.FETCH_BETRIEBE_CLEAR)

    if (data.betriebe) {
      if (data.betriebe.length > 0) {
        if (data.defaultsuche === true) {
          this.dispatch('responseMessage', {
            type: 'info',
            text: 'Leistung nicht gefunden, zeige gesamtes Gewerk'
          })
        }
        if (data.radiusausgeweitet === true) {
          this.dispatch('responseMessage', {
            type: 'info',
            text: 'Leider nur überregionale Betriebe gefunden'
          })
        }
        commit(types.FETCH_BETRIEBE_SUCCESS, { betriebe: data.betriebe })

        commit(types.FETCH_BETRIEBE_SUCCESS_SET_INNUNGEN, { innungen: data.innungen })

        if (payload.suchbegriff) {
          commit(types.SET_BETRIEBE_SUCHBEGRIFFMANUELL, { suchbegriff: payload.suchbegriff })
        }

        if (data.leistung.length === 1) {
          commit(types.SET_BETRIEBE_SUCHBEGRIFF, { suchbegriff: data.leistung[0] })
        }

        commit(types.FETCH_BETRIEBE_SUCCESS_SET_LEISTUNG, { leistung: data.leistung })

        commit(types.FETCH_BETRIEBE_SUCCESS_STANDORT, {
          standort: data.stadt,
          plz: ''
        })
        if (payload.suchbegriff) {
          commit(types.SET_BETRIEBE_SUCHBEGRIFFMANUELL, { suchbegriff: payload.suchbegriff })
        }
        if (payload.plzsuche) {
          commit(types.SET_BETRIEBE_PLZ, { plz: payload.postleitzahl })
        }
        if (data.radius) {
          commit(types.SET_BETRIEBE_RADIUS, { radius: data.radius })
        }
        if (data.kh) {
          commit(types.SET_BETRIEBE_KH, { kh: data.kh })
        }
      } else {
        commit(types.FETCH_BETRIEBE_FAILURE)

        this.dispatch('responseMessage', {
          type: 'warning',
          text: 'Leider keine passenden Betriebe gefunden.'
        })
      }
    }
  },
  async getStartseiteData ({ commit }) {
    let response
    try {
      response = await axios.get('/api/v1/leistungen')
    } catch (ex) {
      commit(types.FETCH_BETRIEBE_FAILURE)
      this.dispatch('responseMessage', {
        type: 'warning',
        text: 'Leider keine Verbindung zum Server.'
      })
      return
    }
    const data = response.data
    if (data.leistungen) {
      commit(types.SET_LEISTUNGEN, { leistungen: data.leistungen })
    }
    if (data.staedte) {
      commit(types.SET_STAEDTE, { staedte: data.staedte })
    }
  },
  loescheBetriebe ({ commit }) {
    commit(types.DELETE_BETRIEBE)
  },

  neueMarkerPosi ({ commit }, payload) {
    commit(types.NEUER_MARKER_SUCCESS, { standort: payload })
  },

// Holt Betriebe für In-Der-Nähe Suche
  async neueMarkerPosiGetBetriebe ({ commit }, payload) {
    commit(types.NEUER_MARKER_SUCCESS, { standort: payload })

    // Lösche alte betriebe
    commit(types.DELETE_BETRIEBE)
    let response
    try {
      response = await axios.get('/api/v1/sucheindernaehe/', {
        params: {
          standort: payload
        }
      })
    } catch (ex) {
     // console.log(response)
      commit(types.FETCH_BETRIEBE_FAILURE)
      return
    }
    const data = response.data

    commit(types.FETCH_BETRIEBE_CLEAR)

    if (data.betriebe) {
      if (data.betriebe.length > 0) {
        commit(types.FETCH_BETRIEBE_SUCCESS, { betriebe: data.betriebe })
      }
    } else {
      commit(types.FETCH_BETRIEBE_FAILURE)
    }
  },
  neueGeolocatePosi ({ commit }, payload) {
  //  console.log(payload)
    commit(types.NEUER_GEOLOCATE_SUCCESS, { standort: payload })
  },
  GeolocateReset ({ commit }) {
    commit(types.GEOLOCATE_RESET)
  },
  neueGeolocatePosiVonStadtWahlButton ({ commit }, payload) {
  //  console.log(payload)
    commit(types.NEUER_GEOLOCATE_DURCH_STADTWAHL_SUCCESS, { standort: payload })
  },
  setStadtGewerk ({ commit }, payload) {
    commit(types.SET_HEIMATSTADT_SUCCESS, { standort: payload })
  },
  loescheHeimatStadt ({ commit }) {
    commit(types.SET_HEIMATSTADT_SUCCESS, { standort: '' })
  }
}

// getters
export const getters = {
  fetchBetriebe: state => {
    return { ...state }
  },
  fetchSuchbegriff: state => {
    return state.suchbegriff
  },
  // fetchLeistungen: state => {
  //   return state.leistungen
  // },
  // fetchStaedte: state => {
  //   return state.staedte
  // },
  fetchStandort: state => {
    return state.standortwert[0]
  },
  leistungenListe: state => {
    return state.leistung
  },
  betriebszahl: state => state.betriebe.length
}
